














































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import MeterReadingCsvMapping from '@/data/models/meter-reading-csv-mapping';
import CreateUpdateStructureCSV from '@/components/meters/detail/CreateUpdateStructureCSV.vue';
import ConfirmDialog from '@/components/ui/ConfirmDialog.vue';
import ImportCSV from '@/components/meters/detail/ImportCSV.vue';
import Button from '@/components/commons/Button.vue';
import Meter from "@/data/models/meter";

@Component({components: {Button, ImportCSV, ConfirmDialog, CreateUpdateStructureCSV}})
export default class ListStructuresCSV extends Vue {
  @Prop({required: true})
  meterId: string;

  opened: boolean = false;
  deleteDialogOpened: boolean = false;
  uploadDialogOpened: boolean = false;

  headers = [
    {text: 'Nom', value: 'filename'},
    {text: 'Colonne de date', value: 'dateColumn'},
    {text: 'Colonne de données', value: 'valueColumn'},
    {text: '', value: 'action', align: 'right'},
  ];
  meterReadings: MeterReadingCsvMapping[] = [];
  meterReading: MeterReadingCsvMapping = MeterReadingCsvMapping.map({});
  isProcessing: boolean = false;
  isCreated: boolean = true;

  meter: Meter = null

  @Watch('meterId', {immediate: true})
  async onMeterIdChange(curr: string): Promise<void> {
    this.getStructures()
    this.meter = await this.$dao.meters.getById(curr)
  }

  handleCreateUpdate(meterReading?: MeterReadingCsvMapping): void {
    this.opened = true;
    this.isCreated = meterReading == null;

    this.meterReading = meterReading != null ? Object.assign(MeterReadingCsvMapping.map({}), meterReading) : MeterReadingCsvMapping.map({meterId: this.meterId});
  }

  handleUpload(meterReading: MeterReadingCsvMapping): void {
    this.uploadDialogOpened = true;

    this.meterReading = meterReading;
  }

  handleDelete(meterReading: MeterReadingCsvMapping): void {
    this.isProcessing = true;

    this.$dao.meters.deleteCSVStructure(meterReading.id).then(() => {
      this.deleteDialogOpened = false;
      this.getStructures();
    });
  }

  openDeleteDialog(meterReading: MeterReadingCsvMapping): void {
    this.meterReading = meterReading;
    this.$dialog.confirm({
      title: this.$t('detailMeter.dialogDeleteTitle').toString(),
      text: this.$t('detailMeter.dialogDeleteText', {name: meterReading.filename}).toString(),
    }).then((confirm) => {
      if (confirm) {
        this.handleDelete(meterReading);
      }
    });
    this.deleteDialogOpened = true;
  }

  dialogClose(): void {
    this.opened = false;
    this.getStructures();
  }

  getStructures(): void {
    this.isProcessing = true;
    this.$dao.meters.getStructuresById(this.meterId).then((result) => {
      if (result != null) {
        this.meterReadings = result;
      }

      this.$emit('availableImportsFilename', this.meterReadings.map((item) => item.filename));

    }).finally(() => this.isProcessing = false);
  }
}
